import { CheckboxProps, FormControl, FormHelperText } from "@mui/material";
import {
  FieldPath,
  FieldValues,
  UseControllerProps,
  get,
  useController,
} from "react-hook-form";
import { Checkbox } from "../Checkbox";

export type FormCheckboxProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = CheckboxProps &
  UseControllerProps<TFieldValues, TName> & {
    label: string;
    help?: React.ReactNode;
    bolded?: boolean;
  };

export const FormCheckbox = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  label,
  bolded = false,
  ...props
}: FormCheckboxProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  const errorMsg = get(formState.errors, name)?.message;

  return (
    <FormControl error={!!errorMsg}>
      <Checkbox
        {...field}
        {...props}
        label={label}
        value={field.value}
        bolded={bolded}
      />
      {errorMsg && <FormHelperText>{errorMsg}</FormHelperText>}
    </FormControl>
  );
};
